// extracted by mini-css-extract-plugin
export default {"ToolTip":"DataToolTip_ToolTip__j+oH1"};